import React, { Fragment } from 'react'
import MarketMoversList from './News';
import Alerts from './Alerts';

import styles from '../controllers/DrawerController.module.scss'

export default function() {
  return (
    <Fragment>
      <div className={styles.drawerSubSection}>
        <div className={styles.drawerSubTitle}>Alerts</div>
        <Alerts />
      </div>
      <div className={styles.drawerSubSection}>
        <div className={styles.drawerSubTitle}>Headliners</div>
        <MarketMoversList />
      </div>
    </Fragment>
  );
}